export const HELP_EMAIL_ADDRESS = 'help@draw.name';

interface EmailTemplateParams {
  to: string;
  subject: string;
  body: string;
}

export const emailTemplateToHref = ({ to, subject, body }: EmailTemplateParams): string => {
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
